// Capacity is planned in whole days; the underlying maths keeps 2dp but nobody budgets 0.76
// of a contractor, so every capacity display rounds to whole days.
export function formatContractDays(days) {
    return Math.round(days || 0).toLocaleString("en-GB")
}

// For user-entered contracted days: shows the value as typed (up to 2dp) rather than rounding,
// so an entered 10.5 never reads back as 11.
export function formatContractDaysExact(days) {
    return (days || 0).toLocaleString("en-GB", { maximumFractionDigits: 2 })
}

// "1 day" / "n days", with sub-half-day values acknowledged rather than rounded to "0 days".
// Exactly zero reads as "0 days" — "less than a day" is reserved for positive fractions.
export function formatContractDaysLabel(days) {
    const value = days || 0
    if (value === 0) return "0 days"
    const rounded = Math.round(value)
    if (rounded === 0) return "less than a day"
    if (rounded === 1) return "1 day"
    return `${formatContractDays(days)} days`
}
